import { render, staticRenderFns } from "./SupplireInfoForm.vue?vue&type=template&id=16defae2&"
import script from "./SupplireInfoForm.vue?vue&type=script&lang=js&"
export * from "./SupplireInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports